export const categories = [
  {
    slug: 'wanghong-baoliao',
    name: '网红爆料',
    description: '各平台网红最新黑料、翻车事件、人设崩塌全纪录',
    icon: 'ri-spy-line',
    count: 1256,
    color: 'from-primary-500/80 to-primary-700/80',
  },
  {
    slug: 'mingxing-heitiao',
    name: '明星黑料',
    description: '娱乐圈明星最新八卦、绯闻、争议事件追踪报道',
    icon: 'ri-star-smile-line',
    count: 983,
    color: 'from-accent-500/80 to-accent-700/80',
  },
  {
    slug: 'remen-zhuizong',
    name: '热门追踪',
    description: '全网最热门吃瓜事件实时追踪与深度分析',
    icon: 'ri-fire-line',
    count: 2145,
    color: 'from-primary-600/80 to-primary-800/80',
  },
  {
    slug: 'chigua-shipin',
    name: '吃瓜视频',
    description: '每日最新吃瓜视频、爆料直播、热门片段合集',
    icon: 'ri-vidicon-line',
    count: 1567,
    color: 'from-accent-600/80 to-accent-800/80',
  },
  {
    slug: 'yule-quan',
    name: '娱乐圈',
    description: '影视圈、音乐圈、综艺圈全方位娱乐资讯',
    icon: 'ri-movie-line',
    count: 1872,
    color: 'from-secondary-500/80 to-secondary-700/80',
  },
  {
    slug: 'zhibo-quan',
    name: '直播圈',
    description: '各大直播平台主播动态、PK恩怨、带货内幕揭秘',
    icon: 'ri-live-line',
    count: 845,
    color: 'from-primary-500/80 to-accent-500/80',
  },
];

export const stats = [
  { label: '累计爆料', value: '12,580', suffix: '条' },
  { label: '活跃吃瓜群众', value: '3,200', suffix: '万' },
  { label: '每日更新', value: '50', suffix: '+' },
  { label: '覆盖平台', value: '36', suffix: '个' },
];